//Styles
import "swiper/css/bundle";
import "air-datepicker/air-datepicker.css";
import "suggestions-jquery/less/suggestions.less";
import "paginationjs/dist/pagination.less";

import "../styles/styles.less";

//need-fast

import "paginationjs/dist/pagination.min";
//blocks
import { blockFunctions } from "./blocks";

//ui
import "./ui";
import { componentsFunctions } from "./components";
import { commonFunctions } from "./common";
import { pagesFunctions } from "./pages";

// //block
blockFunctions();

// //components
componentsFunctions();

//common
commonFunctions();

// //allPages
pagesFunctions();
